import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import React from 'react';
import { isSerialNumberValid } from '../../../../../../common/validation';
import { actions, selectors } from '../../../../../../modules/customer/profile/hardwareProducts';
import HardwareList from './HardwareList';

const anySelectedHardware = (boxList, cardList) => (boxList.length > 0 || cardList.length > 0);
const AddHardwareStep2 = ({boxForm, cardForm}) => {
    const boxList = boxForm.list;
    const cardList = cardForm.list;
    const hasBoxes = boxList.length > 0;
    const hasCards = cardList.length > 0;
    const hasResults = (hasBoxes || hasCards);

    return (
        <div>
            <div className="add-hardware col-xs-12 col-md-6">
                {hasResults && 
                    <div>
                        <div>                            
                            <br/>
                            <span className="info-text" >Hardware listed below will be added. <br/>Please verify and hit OK to send request.</span>
                            <br/>
                        </div>
                        { hasBoxes &&
                            <div>
                                <h2 className="summary-title">Mottaker</h2>
                                <HardwareList hardwareList={boxList} className="compact-list" />
                            </div>
                        }
                        { hasCards && 
                            <div>
                                <h2 className="summary-title">Programkort</h2>
                                <HardwareList hardwareList={cardList} className="compact-list" />
                            </div>
                        }
                    </div>
                }

                { !hasResults &&
                    <div className="text-warning">
                        <h2>Utstyr ikke valgt,</h2>
                        <span>gå tilbake å legg til utstyr</span>
                    </div>
                }
            </div>
        </div>
    )
};

AddHardwareStep2.propTypes = {
}

const mapStateToProps = createStructuredSelector({
    boxForm: selectors.addBoxForm,
    cardForm: selectors.addCardForm
});

export default connect(mapStateToProps)(AddHardwareStep2)